<template>
	<transition>
		<div class="notify" v-if="visible">{{ text }}</div>
	</transition>
</template>

<script>
export default {
	name: 'Notify',
	props: {
		text: {
			type: String,
			default: ''
		}
	},
	data(){
		return {
			visible: false
		}
	},
	mounted() {
		this.visible = true
	}
}
</script>

<style scoped>
.notify{
	position: fixed;
	bottom: 5vw;
	left: 50%;
	transform: translateX(-50%);
	background-color: rgba(0,0,0,0.6);
	color: #fff;
	padding: 1rem 1.5rem;
	font-size: 2rem;
	border-radius: 6px;
}

.v-enter-active, .v-leave-active {
	transition: all 0.5s;
}

.v-enter, .v-leave-to {
	opacity: 0;
	transform: translateX(-50%) translateY(20px);
}

</style>
